import { z } from "zod";
import { createdTimeAway, timeAwayCredit, totalUserTimeAwayCredits } from "./leave.validator";
import { createdProfile } from "./profile.validators";


export const groupedLeaves = z.object({
	upcoming: createdTimeAway.array(),
	done: createdTimeAway.array(),
	pending: createdTimeAway.array(),
	rejected: createdTimeAway.array(),
});
export type GroupedLeaves = z.infer<typeof groupedLeaves>;

export const leaveProfile = createdProfile.pick({
	id: true,
	firstName: true,
	lastName: true,
	jobTitle: true,
	department: true,
	profilePicture: true,
});
export type LeaveProfile = z.infer<typeof leaveProfile>;

const count = z.object({
	requests: z.number().int(),
	employees: z.number().int(),
});

const leaveCounts = z.object({
	allRequests: count,
	upcoming: count,
	done: count,
	pending: count,
	rejected: count,
});

export const findAllTimeAwayFilter = createdTimeAway
	.pick({
		id: true,
		userId: true,
		startDate: true,
		endDate: true,
		timeAwayTypeId: true,
	})
	.extend({
		isApproved: z.enum(["true", "false", "null"]).transform((v) => {
			switch (v) {
				case "true":
					return true;
				case "false":
					return false;
				case "null":
					return null;
			}
		}),
	})
	.partial();

export type LeaveCounts = z.infer<typeof leaveCounts>;

export const manyUsersGroupedLeaves = z.object({
	profiles: leaveProfile.array(),
	credits: totalUserTimeAwayCredits.array(),
	leaves: groupedLeaves,
	count: leaveCounts,
});

export type ManyUsersGroupedLeaves = z.infer<typeof manyUsersGroupedLeaves>;

const timeAwayTableItem = z.object({
	leave: createdTimeAway,
	credit: timeAwayCredit,
	profile: createdProfile.pick({ profilePicture: true, firstName: true, lastName: true }),
});

export type TimeAwayTableItem = z.infer<typeof timeAwayTableItem>;
